<template>
  <div class="alert-box" @click.stop="close" v-show="isShow">
    <div class="cantent" @click.stop>
      <div class="title size12 color66">{{title}}<i class="close el-icon-close size16" @click.stop="close"></i></div>
      <div class="main size12">
        <div>{{title}}不通过备注</div>
        <el-input
          type="textarea"
          :rows="4"
          class="textarea-box"
          size="small"
          placeholder="请输入备注内容..."
          v-model="textarea">
        </el-input>
        <div class="btnBox">
          <el-button size="small" type="primary" style="width: 100px" @click="submit">确定</el-button>
          <el-button size="small" style="width: 100px" @click="close">取消</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      textarea: '',
      isShow: false,
      id: '',
      title: '应用审核',
      type: ''
    }
  },
  created() {

  },
  methods: {
    openAlert(id, type) {
      this.id = id
      this.textarea = ''
      this.type = '' // 默认应用审核
      this.title = "应用审核" // 默认应用审核
      this.isShow = true
      if(type) {
        this.title = "权限审核"
        this.type = type
      }
    },
    close() {
      this.isShow = false
    },
    submit() {
      if(!this.textarea) {
        this.$message({
          message: '请输入备注内容',
          type: 'warning'
        })
        return
      }
      this.$emit('submit',this.id, false ,this.textarea, this.type)
      this.close()
    }
  },
}
</script>
<style scoped>
  /* 小弹窗样式 */
.alert-box{
    width: 100vw;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.4);
    z-index: 100;
    color:#333;
  }
  .alert-box .cantent{
    background: white;
    display: flex;
    flex-direction: column;
    border-radius: 8px;
    overflow: hidden;
    /* padding-bottom: 5px; */
    /* margin-bottom: 30px; */
    display: flex;
    flex-direction: column;
    width:58vw;
    max-width: 800px;
    min-width: 560px;
    max-height: 95%;

  }
  .alert-box .cantent .main{
    flex: 1;
    overflow: auto;
    padding:20px;
  }
  .alert-box .title{
    height: 44px;
    line-height: 44px;
    background:rgba(239,239,239,1);
    border-radius:8px 8px 0px 0px;
    text-align: left;
    padding:0 20px;
    color: #333;
    position: relative;
  }
  .alert-box .title .close{
    color:#666;
    cursor: pointer;
    position:absolute;
    right: 24px;
    top:12px;
    font-size:20px;
  }
  .alert-box .btnBox {
    margin-top:40px;
    text-align: center;
  }
  
  .alert-box .cantent {
    width: 580px;
  }
  .textarea-box {
    border: 1px soldi #999999;
    border-radius:4px;
    margin-top: 10px;
  }
</style>





// WEBPACK FOOTER //
// src/components/developer/approveAlert/approveAlert.vue